import moment from 'moment';

export function constSend() {
    return {
        isFetching: true,
        didInvalidate: false,
    };
}

export function constInvalid() {
    return {
        isFetching: false,
        isNotReady: false,
        didInvalidate: true,
    };
}

export function constValid() {
    return {
        isFetching: false,
        didInvalidate: false,
        isNotReady: false,
    };
}

export function constInitialState() {
    return {
        isFetching: false,
        didInvalidate: false,
        isNotReady: true,
        response: {},
    };
}

export function constInitialStateRequest() {
    return {
        isFetching: false,
        didInvalidate: false,
        isNotReady: true,
    };
}

export function constInitialStateDataTableRequestData() {
    return {
        row: 25,
    };
}

export function constTypesColor() {
    return {
        0: 'blue',
        1: 'purple',
        2: 'pink',
        3: 'red',
        4: 'orange',
        5: 'yellow',
        6: 'green',
        7: 'light-blue',
        8: 'light-green',
    };
}

export function constOnlyCountries() {
    return [
        // "al", "ad", "at", "by", "be", "bg", "hr", "cz", "dk", "ee", "fo",
        // "fi", "fr", "de", "gi", "gr", "va", "hu", "is", "ie", "it", "lv", "li",
        // "lt", "lu", "mk", "mt", "md", "mc", "me", "nl", "no", "pl", "pt", "ro",
        // "ru", "sm", "rs", "sk", "si", "es", "se", "ch", "ua", "gb"
    ];
}

export function constPreferredCountries() {
    return ['ru', 'ua', 'by', 'kz', 'uz'];
}

export function constShortcutsNow() {
    return {
        Вчера: moment().subtract(1, 'days'),
        Сейчас: moment(),
        Очистить: '',
    };
}

export function constShortcutsStartOfDay() {
    return {
        Вчера: moment().startOf('day').subtract(1, 'days'),
        Сегодня: moment().startOf('day'),
        Очистить: '',
    };
}

export function constShortcutsEndOfDay() {
    return {
        Вчера: moment().endOf('day').subtract(1, 'days'),
        Сегодня: moment().endOf('day'),
        Очистить: '',
    };
}

export function constWeeks() {
    return ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
}

export function constMonths() {
    return [
        'Янв',
        'Фев',
        'Мар',
        'Апр',
        'Май',
        'Июн',
        'Июл',
        'Авг',
        'Сен',
        'Окт',
        'Ноя',
        'Дек',
    ];
}

export function modalInitialState() {
    return {
        visible: false,
        initialValues: null,
        onFinish: null,
    };
}
export function typesModalInitialState() {
    return { ...modalInitialState(), initialValues: [] };
}
export function productsModalInitialState() {
    return {
        ...modalInitialState(),
        initialValues: [],
        uuid: null,
    };
}
export const breakPoints = {
    xsMobile: '(min-width : 550px)',
    mobile: '(min-width: 771px)',
    vl: '(min-width: 1400px)',
    xl: '(min-width: 992px)',
    lg: '(min-width: 768px)',
    md: '(min-width: 576px)',
    sm: '(min-width: 1200px)',
};
